module.exports = __webpack_public_path__ + "img/partner01.5b73b68b.png";